document.documentElement.classList.remove('no-js');
(() => {
  const one = (s, root = document) => root.querySelector(s);
  const all = (s, root = document) => [...root.querySelectorAll(s)];
  let menuOpener;
  const closeMenu = (restore = false) => {
    all('[data-mobile-menu]').forEach(menu => menu.removeAttribute('data-open'));
    document.body.classList.remove('menu-open');
    all('[data-menu-toggle]').forEach(button => button.setAttribute('aria-expanded','false'));
    if (restore) menuOpener?.focus();
  };
  all('[data-menu-toggle]').forEach(button => button.addEventListener('click', () => {
    const menu = one('[data-mobile-menu]');
    if (!menu) return;
    if (menu.hasAttribute('data-open')) return closeMenu(true);
    menuOpener = button;
    const header = button.closest('.site-header');
    if (header) menu.style.setProperty('--menu-top', `${header.getBoundingClientRect().bottom}px`);
    menu.setAttribute('data-open','');
    button.setAttribute('aria-expanded','true');
    document.body.classList.add('menu-open');
    one('a', menu)?.focus();
  }));
  all('[data-mobile-menu] a').forEach(link => link.addEventListener('click', () => closeMenu()));
  document.addEventListener('keydown', event => {
    const menu = one('[data-mobile-menu][data-open]');
    if (!menu) return;
    if (event.key === 'Escape') closeMenu(true);
    if (event.key === 'Tab') {
      const controls = [menuOpener, ...all('a,button', menu)].filter(Boolean);
      const index = controls.indexOf(document.activeElement);
      event.preventDefault();
      controls[(index + (event.shiftKey ? -1 : 1) + controls.length) % controls.length]?.focus();
    }
  });
  window.matchMedia('(min-width:901px)').addEventListener('change', event => { if (event.matches) closeMenu(); });
  all('[data-search-toggle]').forEach(button => button.addEventListener('click', () => {
    closeMenu();
    const dialog = one('[data-search-dialog]');
    if (!dialog) return;
    dialog.showModal();
    one('input[type="search"]', dialog)?.focus();
  }));
  all('[data-search-close]').forEach(button => button.addEventListener('click', () => button.closest('dialog')?.close()));
  all('[data-search-dialog]').forEach(dialog => dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  }));

  const init = (root = document) => {
    all('[data-product-gallery]:not([data-enhanced])', root).forEach(gallery => {
      const panels = all('[data-gallery-panel]', gallery);
      const buttons = all('[data-gallery-target]', gallery);
      if (panels.length < 2 || !buttons.length) return;
      const activate = id => {
        if (!panels.some(panel => panel.dataset.galleryPanel === id)) return;
        panels.forEach(panel => { panel.hidden = panel.dataset.galleryPanel !== id; });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.galleryTarget === id)));
      };
      gallery.setAttribute('data-enhanced','');
      activate(buttons[0].dataset.galleryTarget);
      buttons.forEach(button => button.addEventListener('click', () => activate(button.dataset.galleryTarget)));
    });
    all('[data-product-form]:not([data-enhanced])', root).forEach(form => {
      form.setAttribute('data-enhanced','');
      const productRoot = form.closest('[data-product-root]');
      const variant = one('[name="id"]',form);
      const button = one('[type="submit"]',form);
      const errorBox = one('[data-product-error]',form);
      const availability = one('[data-product-availability]',productRoot);
      const price = one('[data-product-price]',productRoot);
      let available = !button.disabled;
      let busy = false;
      variant?.addEventListener('change', () => {
        if (variant.tagName !== 'SELECT') return;
        const option = variant.selectedOptions[0];
        available = option.dataset.available === 'true';
        button.disabled = !available || busy;
        button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
        if (price) price.textContent = option.dataset.price;
        if (availability) {
          availability.classList.toggle('is-sold-out',!available);
          one('[data-availability-text]',availability).textContent = available ? availability.dataset.available : availability.dataset.unavailable;
        }
        const url = new URL(location.href);
        url.searchParams.set('variant',variant.value);
        history.replaceState({},'',url);
        if (errorBox) errorBox.hidden = true;
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || !available) return;
        busy = true;
        button.disabled = true;
        button.setAttribute('aria-busy','true');
        button.textContent = window.aMadeRoutes?.adding || 'Wordt toegevoegd…';
        if (errorBox) errorBox.hidden = true;
        try {
          const rootUrl = window.aMadeRoutes?.root || '/';
          const response = await fetch(rootUrl+'cart/add.js', {method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:new FormData(form)});
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : window.aMadeRoutes?.error);
          const toast = one('[data-cart-toast]');
          if (toast) { toast.hidden = false; toast.classList.add('is-visible'); }
          window.setTimeout(() => { if (toast) { toast.classList.remove('is-visible'); toast.hidden = true; } },7000);
          try {
            const cartResponse = await fetch(rootUrl+'cart.js',{headers:{'Accept':'application/json'}});
            if (cartResponse.ok) { const cart = await cartResponse.json(); all('[data-cart-count]').forEach(node => {node.textContent=cart.item_count;}); }
          } catch {}
        } catch (error) {
          if (errorBox) {errorBox.textContent = error.message || window.aMadeRoutes?.error; errorBox.hidden = false;}
        } finally {
          busy = false;
          button.disabled = !available;
          button.removeAttribute('aria-busy');
          button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
        }
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
